export function getProcessEnv(name: string): string | undefined {
    if (typeof process === "undefined" || !(process as any).env) {
        return undefined;
    }
    const value = (process as any).env[name];
    return typeof value === "string" && value.length > 0 ? value : undefined;
}

export function getImportMetaEnv() {
    // This file is compiled as ESM; CJS builds use utils/env.cjs.ts instead.
    return typeof import.meta !== "undefined" ? import.meta.env : undefined;
}

export function getBrowserEnv(name: string): string | undefined {
    const metaEnv = getImportMetaEnv();
    if (!metaEnv) {
        return undefined;
    }
    const value = metaEnv[name];
    return typeof value === "string" && value.length > 0 ? value : undefined;
}

export function getEnv(name: string, fallback: string): string {
    return getProcessEnv(name) ?? getBrowserEnv(name) ?? fallback;
}
